import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Mail, Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await axios.post(`${API}/contact`, form);
      setState("done");
    } catch {
      setState("idle");
    }
  };

  return (
    <div className="px-4 sm:px-8 lg:px-16 max-w-2xl mx-auto py-12 md:py-16">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-[var(--oz-muted)] hover:text-[var(--oz-text)] mb-8">
        <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
      </Link>
      <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-3">
        Support client
      </span>
      <h1 className="font-serif text-4xl font-medium tracking-tight text-[var(--oz-text)]">Nous contacter</h1>
      <p className="mt-3 text-sm text-[var(--oz-muted)]">
        Une question sur les packs ou votre commande ? Écrivez-nous, nous vous répondrons.
      </p>
      <a href="mailto:pchaubo@hotmail.fr" className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[var(--oz-gold)]">
        <Mail className="w-4 h-4" /> pchaubo@hotmail.fr
      </a>

      {state === "done" ? (
        <div data-testid="contact-success" className="mt-8 bg-white border border-[var(--oz-border)] rounded-2xl p-8 text-center">
          <CheckCircle2 className="w-12 h-12 mx-auto text-[var(--oz-badge)]" />
          <h2 className="font-serif text-2xl mt-4 text-[var(--oz-text)]">Message envoyé</h2>
          <p className="mt-2 text-sm text-[var(--oz-muted)]">Merci, nous reviendrons vers vous rapidement.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 bg-white border border-[var(--oz-border)] rounded-2xl p-6 md:p-8 space-y-5">
          <div>
            <Label htmlFor="name">Nom</Label>
            <Input id="name" data-testid="contact-name" required value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="contact-email" required value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" data-testid="contact-message" required rows={5} value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-1.5" />
          </div>
          <button
            type="submit"
            data-testid="contact-submit"
            disabled={state === "loading"}
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full bg-[var(--oz-dark)] text-white font-semibold text-sm hover:bg-black transition-colors disabled:opacity-60"
          >
            {state === "loading" ? <><Loader2 className="w-4 h-4 animate-spin" /> Envoi…</> : "Envoyer"}
          </button>
        </form>
      )}
    </div>
  );
}
